import { Component, OnInit } from '@angular/core';
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../shared/auth/auth.service";
import {NgxSpinnerService} from "ngx-spinner";
import Me from "../../helpers/me";
import {SocialAuthService} from "angularx-social-login";
import App from "../../helpers/app";
import Api from "../../helpers/api";
import {take} from "rxjs/operators";
import * as moment from 'moment';
import {ExcelService} from "../../helpers/excel.service";
import * as Chartist from 'chartist';
import { ChartType, ChartEvent } from "ng-chartist";
import ChartistTooltip from 'chartist-plugin-tooltips-updated';
import {ChartDataSets, ChartOptions} from "chart.js";
import {Label} from "ng2-charts";
import {now} from "moment";

export interface Chart {
  type: ChartType;
  data: Chartist.IChartistData;
  options?: any;
  responsiveOptions?: any;
  events?: ChartEvent;
  // plugins?: any;
}

@Component({
  selector: 'app-admin-home',
  templateUrl: './admin-home.component.html',
  styleUrls: ['./admin-home.component.scss']
})
export class AdminHomeComponent implements OnInit {
  apiCall = this.api.new().silent();
  usuarios = []
  usuariosFiltered = []
  usuariosDetails = []
  userView
  training
  avaliation
  execution
  programa
  desafio
  mural
  pageAD = 1
  pageSizeAD = 10
  nomeLista
  page = 1
  pageSize = 10
  tipos = [
    {
      id: null,
      name: 'Todos',
    },
    {
    id: '1',
    name: 'Aluno',
  },{
    id: '0',
    name: 'Personal',
  }]
  status = [
    {
      id: null,
      name: 'Todos',
    },
    {
    id: true,
    name: 'Ativo',
  },{
    id: false,
    name: 'Inativo',
  }]
  offset = 0
  limit = 1000
  constructor(private modalService: NgbModal,
              private router: Router,
              private authService: AuthService,
              private spinner: NgxSpinnerService,
              private route: ActivatedRoute,
              private me: Me,
              private socialAuthService: SocialAuthService,
              private app: App,
              private excelService: ExcelService,
              private api: Api) {
  }
  async ngOnInit() {
    const self = this

    self.usuarios = []
    self.usuariosFiltered = []
    self.userView = null
    self.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    const dataTecnico = await self.apiCall.get('dashboard/tecnico').pipe(take(1)).toPromise()
    if(dataTecnico && dataTecnico.return){
      self.training = dataTecnico.return.training
      self.avaliation = dataTecnico.return.avaliation
      self.execution = dataTecnico.return.execution
      self.programa = dataTecnico.return.programa
      self.desafio = dataTecnico.return.desafio
      self.mural = dataTecnico.return.mural
    }
   
    let dataUsuarios = null//await self.apiCall.get(`users/${self.offset}/${self.limit}`).pipe(take(1)).toPromise()
    let totalRows = []
    let hasMoreRows = false
    if(dataUsuarios.return && dataUsuarios.return.count && dataUsuarios.return.count>(self.offset+self.limit)) hasMoreRows = true
    if(dataUsuarios.return && dataUsuarios.return.rows){
      for(let t of dataUsuarios.return.rows){
        totalRows.push(t)
      }
    }

    while (hasMoreRows){
      self.offset = self.offset + 1000
      //self.limit = 1000
      console.log('ta rodando dnv', self.offset)
      dataUsuarios = await self.apiCall.get(`users/${self.offset}/${self.limit}`).pipe(take(1)).toPromise()
      if(dataUsuarios.return && dataUsuarios.return.count && dataUsuarios.return.count>(self.offset+self.limit)){
        hasMoreRows = true
      }else{
        hasMoreRows = false
      }
      if(dataUsuarios.return && dataUsuarios.return.rows){
        for(let t of dataUsuarios.return.rows){
          totalRows.push(t)
        }
      }
    }
    if(totalRows){
      self.usuarios = JSON.parse(JSON.stringify(totalRows.filter(t=>t.type!='2')))
      self.usuarios =self.usuarios.sort((a, b) => a.name && a.name.localeCompare(b.name))
      self.usuariosFiltered = self.usuarios
    }
    self.spinner.hide()
  }
  getTotalType(personal){
    if(personal){
      return this.usuariosFiltered ? this.usuariosFiltered.filter(x=>x.type=='0').length : 0
    }else{
      return this.usuariosFiltered ? this.usuariosFiltered.filter(x=>x.type=='1').length : 0
    }
  }
  formatDate(lastLogin){
    return moment(lastLogin).format('DD/MM/YYYY HH:mm')
  }
  formatDateWithoutTime(lastLogin){
    return moment(lastLogin).format('DD/MM/YYYY')
  }
}
